import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchLoans } from '../../features/loans/loanAPI';
import { CivicIdBadge } from './CivicIdBadge';
import LoanRequestCard from './LoanRequestCard';

export default function LoanRequestBoard() {
  const dispatch = useDispatch();
  const [filterButtons, setFilterButtons] = useState([
    {
      id: 'all',
      label: 'All Requests',
      isActive: true
    },
    {
      id: 'highest',
      label: 'Highest',
      isActive: false
    },
    {
      id: 'lowest',
      label: 'Lowest',
      isActive: false
    },
    {
      id: 'newest',
      label: 'Newest',
      isActive: false
    },
    {
      id: 'oldest',
      label: 'Oldest',
      isActive: false
    },
    /* {
      id: 'lend',
      label: 'Lenders',
      isActive: false
    },
    {
      id: 'borrow',
      label: 'Borrowers',
      isActive: false
    }, */
    {
      id: 'urgent',
      label: 'Urgent',
      isActive: false
    }
  ]);
  const username = useSelector((state) => state.auth.username);
  const floanRequests = useSelector((state) => state.loans.loans.floans);
  const [sortedLoans, setSortedLoans] = useState(floanRequests);
  const [type, setType] = useState("all");
  const [search, setSearch] = useState(0);

  useEffect(() => {
    const Loan = async () => {
      await dispatch(fetchLoans())
        .unwrap()
        .then(() => {
          console.log('Loan fetched successfully');
        })
        .catch((error) => {
          console.error('Error fetching loan:', error.message || error);
        })
    };
    Loan();
  }, [dispatch, username]);

  useEffect(() => {
    const originalLoanRequests = [...floanRequests];

    if (type === "lend" || type === "borrow") {
      type === "lend" && setSortedLoans(originalLoanRequests.filter(loan => loan.lenderUser));
      type === "borrow" && setSortedLoans(originalLoanRequests.filter(loan => loan.borrowerUser));
    } else {
      const sortedLoan = originalLoanRequests.sort((a, b) => {
        if (type === "highest") return parseInt(b.loanAmount) - parseInt(a.loanAmount);
        if (type === "lowest") return parseInt(a.loanAmount) - parseInt(b.loanAmount);
        if (type === "newest") return new Date(b.days) - new Date(a.days);
        if (type === "oldest") return new Date(a.days) - new Date(b.days);
        return 0;
      });
      setSortedLoans(sortedLoan);
    }
  }, [dispatch, floanRequests]);

  const handleSort = (order) => {
    setType(order);
    const originalLoanRequests = [...floanRequests];

    setFilterButtons((prevButtons) =>
      prevButtons.map((button) => ({
        ...button,
        isActive: button.id === order,
      }))
    );

    if (order === "lend" || order === "borrow") {
      order === "lend" && setSortedLoans(originalLoanRequests.filter(loan => loan.lenderUser));
      order === "borrow" && setSortedLoans(originalLoanRequests.filter(loan => loan.borrowerUser));
    } else {
      const sortedLoan = originalLoanRequests.sort((a, b) => {
        if (order === "highest") return parseInt(b.loanAmount) - parseInt(a.loanAmount);
        if (order === "lowest") return parseInt(a.loanAmount) - parseInt(b.loanAmount);
        if (order === "newest") return new Date(b.days) - new Date(a.days);
        if (order === "oldest") return new Date(a.days) - new Date(b.days);
        return 0;
      });
      setSortedLoans(sortedLoan);
    }
  };

  const handleSearch = (event) => {
    event.preventDefault();
    const originalLoanRequests = floanRequests;
    setSortedLoans(originalLoanRequests.filter(loan => loan.loanAmount === Number(search)));
  };

  return (
    <main className="flex overflow-hidden flex-col items-center py-20 pl-16 pr-16 w-full bg-white max-md:pl-5 max-md:pr-5 max-md:max-w-full">
      <CivicIdBadge />

      <section className="flex flex-wrap gap-5 justify-between mt-9 w-full max-w-[1290px] max-md:max-w-full">
        <h1 className="text-5xl leading-none text-slate-900 max-md:max-w-full">
          Request Board for Microloans
        </h1>
        <button
          className="flex gap-4 items-center my-auto h-10 text-base font-medium leading-none text-center text-white overflow-hidden gap-5 self-stretch px-5 py-4 my-auto bg-blue-600 rounded-lg min-h-[45px]"
          aria-label="Repay Loan"
        >
          <Link to="/repay">Repay Loan</Link>
        </button>
      </section>

      <section className="flex flex-wrap gap-5 justify-between p-2 mt-8 w-full text-lg leading-8 border border-solid border-stone-300 max-w-[1315px] rounded-[49px] max-md:max-w-full">
        <div className="flex flex-wrap gap-5 items-center max-md:max-w-full">
          {filterButtons.map(button => (
            <button
              key={button.id}
              onClick={() => handleSort(button.id)}
              className={`gap-2.5 self-stretch px-6 py-1.5 my-auto min-h-[42px] rounded-[49px] ${button.isActive ? 'bg-blue-600 text-white' : 'bg-neutral-100 text-zinc-500'}`}
              aria-pressed={button.isActive}
            >
              {button.label}
            </button>
          ))}
        </div>
        <form onSubmit={(e) => handleSearch(e)} className="flex gap-5 px-3.5 py-1.5 border border-solid border-neutral-400 rounded-[49px] text-zinc-500">
          <label htmlFor="searchRequest" className="sr-only">Search request</label>
          <input
            type="number"
            min="0"
            id="searchRequest"
            onChange={(e) => setSearch(e.target.value)}
            className="flex-auto bg-transparent border-none outline-none"
            placeholder="Search request"
          />
          <button
            type="submit"
            aria-label="Search"
            className="p-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </button>
        </form>
      </section>

      <section
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12 w-full max-w-[1315px]"
        aria-label="Loan Requests"
      >
        {sortedLoans.map(loan => (
          <LoanRequestCard key={loan._id} {...loan} />
        ))}
      </section>

      <button
        className="overflow-hidden gap-5 self-center px-5 py-3.5 mt-14 max-w-full text-base text-center text-white bg-blue-600 rounded-lg min-h-[46px] shadow-[0px_1px_5px_rgba(0,0,0,0.25)] w-[274px] max-md:mt-10"
        aria-label="Load More Loan Requests"
      >
        Load More
      </button>
    </main>
  );
}